'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var index$2 = require('../message/index.js');

var index = require('../wantlist/index.js');

var constants = require('../constants.js');

var msgQueue = require('./msg-queue.js');

var index$1 = require('../utils/index.js');

var base58 = require('multiformats/bases/base58');

var WantManager = /*#__PURE__*/function () {
  function WantManager(peerId, network, stats) {
    _classCallCheck(this, WantManager);

    this.peers = new Map();
    this.wantlist = new index.Wantlist(stats);
    this.network = network;
    this._stats = stats;
    this._peerId = peerId;
    this._log = index$1.logger(peerId, 'want');
  }

  _createClass(WantManager, [{
    key: "_addEntries",
    value: function _addEntries(cids, cancel, force) {
      var _this = this;

      var entries = cids.map(function (cid, i) {
        return new index$2.BitswapMessage.Entry(cid, constants.kMaxPriority - i, index$2.BitswapMessage.WantType.Block, cancel);
      });
      entries.forEach(function (e) {
        if (e.cancel) {
          if (force) {
            _this.wantlist.removeForce(e.cid.toString(base58.base58btc));
          } else {
            _this.wantlist.remove(e.cid);
          }
        } else {
          _this._log('adding to wl');

          _this.wantlist.add(e.cid, e.priority);
        }
      });

      var _iterator = _createForOfIteratorHelper(this.peers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          p.addEntries(entries);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_startPeerHandler",
    value: function _startPeerHandler(peerId) {
      var mq = this.peers.get(peerId.toB58String());

      if (mq) {
        mq.refcnt++;
        return;
      }

      mq = new msgQueue.MsgQueue(this._peerId, peerId, this.network);
      var fullwantlist = new index$2.BitswapMessage(true);

      var _iterator2 = _createForOfIteratorHelper(this.wantlist.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;
          fullwantlist.addEntry(entry[1].cid, entry[1].priority);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      mq.addMessage(fullwantlist);
      this.peers.set(peerId.toB58String(), mq);
      return mq;
    }
  }, {
    key: "_stopPeerHandler",
    value: function _stopPeerHandler(peerId) {
      var mq = this.peers.get(peerId.toB58String());

      if (!mq) {
        return;
      }

      mq.refcnt--;

      if (mq.refcnt > 0) {
        return;
      }

      this.peers.delete(peerId.toB58String());
    }
  }, {
    key: "wantBlocks",
    value: function wantBlocks(cids) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._addEntries(cids, false);

      if (options && options.signal) {
        options.signal.addEventListener('abort', function () {
          _this2.cancelWants(cids);
        });
      }
    }
  }, {
    key: "unwantBlocks",
    value: function unwantBlocks(cids) {
      this._log('unwant blocks: %s', cids.length);

      this._addEntries(cids, true, true);
    }
  }, {
    key: "cancelWants",
    value: function cancelWants(cids) {
      this._log('cancel wants: %s', cids.length);

      this._addEntries(cids, true);
    }
  }, {
    key: "connectedPeers",
    value: function connectedPeers() {
      return Array.from(this.peers.keys());
    }
  }, {
    key: "connected",
    value: function connected(peerId) {
      this._startPeerHandler(peerId);
    }
  }, {
    key: "disconnected",
    value: function disconnected(peerId) {
      this._stopPeerHandler(peerId);
    }
  }, {
    key: "start",
    value: function start() {}
  }, {
    key: "stop",
    value: function stop() {
      var _this3 = this;

      this.peers.forEach(function (mq) {
        return _this3.disconnected(mq.peerId);
      });
    }
  }]);

  return WantManager;
}();

exports.WantManager = WantManager;